import { ItemId } from '../../../game/demo/inventory/items';

export type InventoryState = {
  items: Record<string, number>;
};

export type InventoryEffect =
  | { type: 'grant'; item: ItemId; quantity: number }
  | { type: 'consume'; item: ItemId; quantity: number };

export enum InventoryEventBus {
  changed = 'inventoryChanged',
}

export interface InventoryReader {
  getState(): Readonly<InventoryState>;
}
